import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';
import { Metric } from 'hooks/search';
import { Empty } from 'antd';
import { map } from 'lodash';
import { Container } from './styles';
import MostCitedTermsChart from './MostCitedTermsChart';

interface TermData {
  name: string;
  value: number;
}

interface MostCitedTermsWrapperProps {
  title: string;
  data: TermData[];
}

const MostCitedTermsWrapper: React.FC<MostCitedTermsWrapperProps> = ({
  data,
  title,
}) => {
  const XAxis = data.map((item: TermData) => item.name);

  return (
    <Container>
      <MostCitedTermsChart
        XAxis={XAxis}
        title={title}
        legend={map(data, 'name')}
        data={data}
      />
    </Container>
  );
};

export default MostCitedTermsWrapper;
